/*! @pentacode/ui v0.1.0 */
//#region src/elements/table/table.util.ts
var e = (e) => e.field;
function t(e, t) {
	let n = t.split("."), r = e;
	for (let e of n) r = r?.[e];
	return r;
}
//#endregion
export { e as fieldOf, t as getFieldValue };

//# sourceMappingURL=table.util.js.map